































import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceAvailabilityList'

  vue:
    props: ['wizard', 'selectable', 'selected']

    computed:
      audienceAvailabilities: -> @wizard.audienceSetData.audience_availabilities
      venues: -> @wizard.audienceSetData.venues

      hasHeaderSlot: -> @$slots.header?

      selectedKeys:
        get: -> @selected
        set: (value) -> @$emit('update:selected', value)

export default VueOptions.vue settings
